import React from "react";

export const burgerMenu = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3335 11.9997H6.66683C5.93045 11.9997 5.3335 11.4027 5.3335 10.6663C5.3335 9.92996 5.93045 9.33301 6.66683 9.33301H25.3335C26.0699 9.33301 26.6668 9.92996 26.6668 10.6663C26.6668 11.4027 26.0699 11.9997 25.3335 11.9997ZM25.3335 22.6663H6.66683C5.93045 22.6663 5.3335 22.0694 5.3335 21.333C5.3335 20.5966 5.93045 19.9997 6.66683 19.9997H25.3335C26.0699 19.9997 26.6668 20.5966 26.6668 21.333C26.6668 22.0694 26.0699 22.6663 25.3335 22.6663Z"
        fill="currentColor"
      />
    </svg>
  );
};
